import NeighborhoodPageContent from "../NeighborhoodPageContent";

export default function Churriana() {
  return <NeighborhoodPageContent slug="churriana" />;
}